import {
  INVALID_PHONE_NUMBER_MESSAGE,
  REQUIRED_FIELD_MESSAGE,
} from "./constants";

const PHONE_DIGIT_MIN = 7;
const PHONE_DIGIT_MAX = 15;
const INVALID_PHONE_CHARACTERS = /[^0-9+()\-\s]/g;

export const sanitizePhoneNumberInput = (value: string): string =>
  value
    .replace(INVALID_PHONE_CHARACTERS, "")
    .replace(/(?!^)\+/g, "")
    .replace(/\s{2,}/g, " ");

export const validatePhoneNumber = (
  value: string | null | undefined,
  options?: { required?: boolean },
): string | null => {
  const trimmedValue = value?.trim() || "";

  if (!trimmedValue) {
    return options?.required ? REQUIRED_FIELD_MESSAGE : null;
  }

  if (trimmedValue !== sanitizePhoneNumberInput(trimmedValue)) {
    return INVALID_PHONE_NUMBER_MESSAGE;
  }

  const digits = trimmedValue.replace(/\D/g, "");
  if (digits.length < PHONE_DIGIT_MIN || digits.length > PHONE_DIGIT_MAX) {
    return INVALID_PHONE_NUMBER_MESSAGE;
  }

  return null;
};
